import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_3 = { class: "gfu-grid__cell gfu-6of12" }
const _hoisted_4 = { class: "gfu-grid__cell gfu-6of12" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field_label = _resolveComponent("field-label")
  const _component_date_field = _resolveComponent("date-field")

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "gfu-grid__cell gfu-1of3 _mt-1",
        "data-qa": `filtersbox-field:${_ctx.displayName}`
      }, [
        _createVNode(_component_field_label, {
          class: "gfu-field__label--gray _mt-1",
          text: _ctx.displayName
        }, null, 8 /* PROPS */, ["text"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_date_field, {
              modelValue: _ctx.minDateModel,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = $event => ((_ctx.minDateModel) = $event)),
                $options.onChange
              ],
              class: "_ma-0",
              "display-name": "Min date",
              name: "model.minDate",
              "show-label": false,
              small: true,
              "value-type": "auto",
              "data-qa": "date-field:MinDate"
            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "gfu-divider gfu-divider--small" }, "to", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_date_field, {
              modelValue: _ctx.maxDateModel,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = $event => ((_ctx.maxDateModel) = $event)),
                $options.onChange
              ],
              class: "_ma-0",
              "display-name": "Max date",
              name: "model.minDate",
              "show-label": false,
              small: true,
              "value-type": "auto",
              "data-qa": "date-field:MaxDate"
            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
          ])
        ])
      ], 8 /* PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}